export const OBERSTE_GESCHOSSDECKE = 'oberste Geschossdecke';
export const WAERMEERZEUGER = 'Wärmeerzeuger';
export const WAERMEVERTEILUNG_ABGABE = 'Wärmeverteilung / -abgabe';
export const SONSTIGES = 'Sonstiges';
